import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { MapPreview } from './components/MapPreview';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { useAutoUpdate } from './hooks/useAutoUpdate';

export default function App() {
  // Autoactualización al reabrir desde la pantalla de inicio del iPhone.
  useAutoUpdate();

  // Mantiene <html lang> al día con el idioma resuelto (también al
  // autodetectarlo, no solo al pulsar el selector) para coherencia con hreflang.
  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'es';
    if (document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [i18n.resolvedLanguage]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <MapPreview />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
